<template>
  <div v-if="isPromptActiveLocal ? true : false">
    information de l'evaluation
  </div>
</template>

<script>
export default {
  name: "Otd2AddEvaluationInfo",

  data() {
    return {
        tree_select_settings: {
        clearable: true,
        searchable: true,
        openOnClick: true,
        autoLoadRrootOptions: false,
        multiple: true,
        disableBranchNodes: false,
        showCount: true,
        valueConsistsOf: "LEAF_PRIORITY",
      },
    };
  },
  props: {
    isPromptActive: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    isPromptActive(val) {
      if (!val) return;
    },
  },
  computed: {
    isPromptActiveLocal: {
      get() {
        if (this.isPromptActive) {
        }
        return this.isPromptActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closePrompt");
        }
      },
    },
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
</style>